import { render } from "./LeadHistory.vue?vue&type=template&id=dc37806a&scoped=true"
import script from "./LeadHistory.vue?vue&type=script&lang=js"
export * from "./LeadHistory.vue?vue&type=script&lang=js"

import "./LeadHistory.vue?vue&type=style&index=0&id=dc37806a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc37806a"]])

export default __exports__